import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MyTitle from "../../components/MyTitle";

const Privacy = () => {
  return (
    <div className="privacy-content">
      <p className="mb-5">
        K-CDH는 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고
        개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은
        처리방침을 두고 있습니다.
      </p>

      <p className="mb-5">
        K-CDH는 K-CDH 통합 및 개별 서비스에 등록하거나 서비스를 이용할 때 회원의
        개인정보를 수집하며, 해당 개인정보를 이용하여 회원이 요청한 서비스의
        제공, 회원 등록 및 정보 전송 등을 할 권한을 가집니다. K-CDH는
        개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을
        통하여 공지할 것입니다.
      </p>

      <p className="text-gray-dark mb-5">{"< 다 음 >"}</p>

      {/* Start */}
      <MyTitle title="제1조 개인정보의 수집 및 이용 목적" className="mb-4" />

      <p className="font-medium mb-4">
        K-CDH ‘www.k-cdh.org’ 는 개인정보를 다음의 목적을 위해 이용합니다.
        처리한 개인정보는 다음의 목적 이외의 용도로는 사용되지 않으며, 이용
        목적이 변경될 시에는 사전동의를 구할 예정입니다.
      </p>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p>
            홈페이지 회원가입 및 관리 회원 가입의사 확인, 회원자격 유지·관리,
            서비스 부정이용 방지, 각종 고지·통지, 분쟁 조정을 위한 기록 보존
            등을 목적으로 개인정보를 처리합니다
          </p>
        </li>
        <li>
          <p>
            민원사무 처리 민원인의 신원 확인, 민원사항 확인, 처리결과 통보 등을
            목적으로 개인정보를 처리합니다.
          </p>
        </li>
        <li>
          <p>
            재화 또는 서비스 제공 서비스 제공, 콘텐츠 제공, 맞춤 서비스 제공,
            본인인증 등을 목적으로 개인정보를 처리합니다.
          </p>
        </li>
        <li>
          <p className="mb-1">마케팅 및 광고에의 활용</p>
          <p className="text-gray-dark">
            신규 서비스(제품) 개발 및 맞춤 서비스 제공, 서비스의 유효성 확인,
            접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로
            개인정보를 처리합니다. 단, 마케팅 또는 광고를 위해 제3자에게
            개인정보를 이전하는 경우에는 별도의 사전동의를 받도록 합니다.
          </p>
        </li>
      </ul>

      <MyTitle title="제2조 개인정보 항목 및 수집방법" className="mb-4" />

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p>
            개인정보 항목 : 이름,이메일, 비밀번호, 로그인ID, 서비스 이용 기록,
            접속 로그, 쿠키, 접속 IP 정보, 소속기관, 휴대전화번호.
          </p>
        </li>
        <li>
          <p>
            수집방법 : 서비스 회원가입시 또는 개별 서비스 이용과정을 통한 수집.
          </p>
        </li>
        <li>
          <p>보유근거 : 당사 개인정보처리방침.</p>
        </li>
        <li>
          <p>
            보유기간 : 개인정보의 수집 및 이용목적이 달성되면 즉시 파기
            (회원탈퇴 시 파기).
          </p>
        </li>
      </ul>

      <MyTitle title="제3조 개인정보의 처리 및 보유 기간" className="mb-4" />

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p>
            K-CDH 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터
            개인정보를 수집시에 동의 받은 개인정보 보유, 이용기간 내에서
            개인정보를 처리, 보유합니다.
          </p>
        </li>
        <li>
          <p className="mb-1">
            각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
          </p>
          <p className="mb-4">{"< 홈페이지 회원가입 및 관리 >"}</p>

          <ul className="list-decimal pl-12 flex flex-col gap-3">
            <li>
              <p className="text-gray-dark">
                K-CDH는 원칙적으로 이용자의 개인정보를 회원 탈퇴 시 지체없이
                파기하고 있습니다.
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                단, 이용자에게 개인정보 보관기간에 대해 별도의 동의를 얻은 경우,
                또는 법령에서 일정 기간 정보보관 의무를 부과하는 경우에는 해당
                기간 동안 개인정보를 안전하게 보관합니다.
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                보유근거 : 개인정보보호법, 통신비밀보호법 및 당사
                개인정보처리방침.
              </p>
            </li>
          </ul>
        </li>
      </ul>

      <MyTitle
        title="제4조 정보주체와 법정대리인의 권리·의무 및 그 행사방법"
        className="mb-4"
      />

      <p className="font-medium mb-4">
        이용자는 개인정보주체로써 다음과 같은 권리를 행사할 수 있습니다.
      </p>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p>
            정보주체는 회원 가입 기간 동안 회사에 대해 언제든지 개인정보 열람,
            정정, 삭제, 처리정지 요구 등의 권리를 행사할 수 있습니다.
          </p>
        </li>
        <li>
          <p>
            제1항에 따른 권리 행사는 회사에 대해 개인정보 보호법 시행령
            제41조제1항에 따라 서면, 전자우편 등을 통하여 하실 수 있으며 K-CDH는
            이에 대해 지체 없이 조치하겠습니다.
          </p>
        </li>
        <li>
          <p>
            제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등
            대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙
            별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
          </p>
        </li>
        <li>
          <p>
            개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조 제5항, 제37조
            제2항에 의하여 정보주체의 권리가 제한될 수 있습니다.
          </p>
        </li>
        <li>
          <p>
            개인정보의 정정 및 삭제 요구를 하였으나 다른 법령에서 그 개인정보가
            수집 대상으로 명시되어 있는 경우, K-CDH는 이를 거절할 수 있습니다.
            K-CDH는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구,
            처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한
            대리인인지를 확인합니다.
          </p>
        </li>
      </ul>

      <MyTitle title="제5조 처리하는 개인정보의 항목 작성" className="mb-4" />

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-4">
        <li>
          <p>
            K-CDH는 통합서비스를 포함하여 개별 서비스에서 다음의 개인정보 항목을
            처리하고 있습니다.
          </p>
        </li>
      </ul>

      <table className="w-full border-collapse mb-10">
        <thead>
          <tr>
            <th
              className="border border-gray-border p-2 text-left bg-[#F8F8FA] font-semibold"
              width="50%"
            >
              서비스
            </th>
            <th
              className="border border-gray-border p-2 text-left bg-[#F8F8FA] font-semibold"
              width="50%"
            >
              필수항목
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border border-gray-border p-2 text-gray-dark">
              통합서비스 회원가입 및 관리
            </td>
            <td className="border border-gray-border p-2 text-gray-dark">
              이름, 로그인ID, 이메일, 비밀번호
            </td>
          </tr>
        </tbody>
      </table>

      <MyTitle title="제6조 개인정보의 파기" className="mb-4" />

      <p className="font-medium mb-4">
        K-CDH는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당
        개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.
      </p>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p className="mb-1">파기절차</p>
          <p className="text-gray-dark">
            이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우
            별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후
            혹은 즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한
            경우가 아니고서는 다른 목적으로 이용되지 않습니다.
          </p>
        </li>
        <li>
          <p className="mb-1">파기기한</p>
          <p className="text-gray-dark">
            이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의
            종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의
            폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는
            개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그
            개인정보를 파기합니다.
          </p>
        </li>
        <li>
          <p className="mb-1">파기방법</p>
          <ul className="flex flex-col gap-3">
            <li>
              <p className="text-gray-dark">
                - 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을
                사용합니다
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                - 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여
                파기합니다.
              </p>
            </li>
          </ul>
        </li>
      </ul>

      <MyTitle
        title="제7조 개인정보 자동 수집 장치의 설치•운영 및 거부에 관한 사항"
        className="mb-4"
      />

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p>
            회사에서 제공하는 서비스는 개별적인 맞춤서비스를 제공하기 위해
            이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.
          </p>
        </li>
        <li>
          <p className="mb-2">
            쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터
            브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의
            하드디스크에 저장되기도 합니다.
          </p>
          <ul className="flex flex-col gap-3">
            <li>
              <p className="text-gray-dark">
                - 가. 쿠키의 사용 목적 : 이용자가 방문한 각 서비스와 웹
                사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부,
                등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용되며, 타
                사유에 의한 쿠키 사용은 제한 됩니다.
              </p>
            </li>
            <li>
              <p className="text-gray-dark">
                {
                  "- 나. 쿠키의 설치•운영 및 거부 : 웹브라우저 상단의 도구<인터넷 옵션<개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부할 수 있습니다. 단, 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있으며 이로 인한 이용자의 불편 및 손해에 대해서 K-CDH는 책임을 면합니다."
                }
              </p>
            </li>
          </ul>
        </li>
      </ul>

      <MyTitle title="제8조 개인정보 보호책임자 작성" className="mb-4" />

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p className="mb-4">
            K-CDH는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보
            처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와
            같이 개인정보 보호책임자를 지정하고 있습니다.
          </p>
          <p className="mb-2">
            <FontAwesomeIcon icon={faCaretRight} size="lg" className="mr-4" />
            개인정보 보호책임자
          </p>
          <ul className="flex flex-col gap-3">
            <li>
              <p className="text-gray-dark">- 책임자 성명: 정지윤</p>
            </li>
            <li>
              <p className="text-gray-dark">- 직책: 서울아산병원 신생아과</p>
            </li>
            <li>
              <p className="text-gray-dark">- 연락처: 02-3010-3390</p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            정보주체께서는 회사의 서비스(또는 사업)를 이용하시면서 발생한 모든
            개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을
            개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 통합서비스
            이하 운영 서비스는 정보주체의 문의에 대해 지체 없이 답변 및
            처리해드릴 것입니다.
          </p>
        </li>
      </ul>

      <MyTitle title="제9조 개인정보의 안전성 확보 조치" className="mb-4" />

      <p className="font-medium mb-4">
        K-CDH는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한
        기술적/관리적 및 물리적 조치를 하고 있습니다.
      </p>

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p className="mb-1">정기적인 자체 감사 실시</p>
          <p className="text-gray-dark">
            개인정보 취급 관련 안정성 확보를 위해 정기적으로 자체 감사를
            실시하고 있습니다.
          </p>
        </li>
        <li>
          <p className="mb-1">개인정보 취급 직원의 최소화 및 교육</p>
          <p className="text-gray-dark">
            개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화하여
            개인정보를 관리하는 대책을 시행하고 있습니다.
          </p>
        </li>
        <li>
          <p className="mb-1">내부관리계획의 수립 및 시행</p>
          <p className="text-gray-dark">
            개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고
            있습니다.
          </p>
        </li>
        <li>
          <p className="mb-1">해킹 등에 대비한 기술적 대책</p>
          <p className="text-gray-dark">
            K-CDH는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을
            막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며
            외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로
            감시 및 차단하고 있습니다.
          </p>
        </li>
        <li>
          <p className="mb-1">개인정보의 암호화</p>
          <p className="text-gray-dark">
            이용자의 개인정보는 비밀번호는 암호화되어 저장 및 관리되고 있어,
            본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를
            암호화하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고
            있습니다.
          </p>
        </li>
        <li>
          <p>
            다만, 이러한 회사의 모든 조치가 안정성을 완전히 보장하는 것이라고
            해석할 수는 없습니다.
          </p>
        </li>
      </ul>

      <MyTitle title="제10조 개인정보 처리방침 변경" className="mb-4" />

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p>
            이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른
            변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일
            전부터 공지사항을 통하여 고지할 것입니다. 본 개인정보처리방침에
            규정되어 있지 않은 사항에 대한 분쟁은 개인정보보호법, 통신비밀보호법
            등 적용법률에 따라 해석됩니다.
          </p>
        </li>
      </ul>

      <MyTitle
        title="제11조 개인정보 처리방침의 변경에 관한 사항"
        className="mb-4"
      />

      <ul className="list-decimal pl-8 flex flex-col gap-3 mb-10">
        <li>
          <p>개인정보 처리방침은 2025.04.1부터 적용됩니다.</p>
        </li>
      </ul>
    </div>
  );
};

export default Privacy;
